import {AppConst} from "@/classes/app/app-const";

export class WorktimeUtil {
    public static get ws(): string[] {
        return AppConst.Weeks;
    }
}
